import { Component } from '@angular/core';
import { PagesHeaderComponent } from '../../components/pages-header/pages-header.component';
import { BuyerFooterComponent } from '../../../../Shared/components/buyer-footer/buyer-footer.component';
import { BlogComponent } from '../../../../Shared/components/blog/blog.component';
import { AnimateOnScrollDirective } from '../../../../Shared/directives/AnimateOnScroll/animate-on-scroll.directive';
import { Breadcrumb } from 'src/app/Shared/_models/breadcrumb.model';
import { BreadCrumbsComponent } from '../../../../Shared/components/bread-crumbs/bread-crumbs.component';
import { PaginationComponent } from '../../../../Shared/components/pagination/pagination.component';

import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslatePipe, TranslateService} from '@ngx-translate/core';
import {
  map,
  catchError,
  of,
  forkJoin,
  Observable,
  switchMap,
} from 'rxjs';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { LandingService } from '../../_services/landing.service';
import { LocalDateTimePipe } from 'src/app/Shared/_pipes/local-date-time';
import { getPaginationData } from 'src/app/_utlis/pagination-helper';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';

import { SkeletonLoaderComponent } from 'src/app/Shared/components/skeleton-loader/skeleton-loader.component';

export interface BlogItem {
  id: number;
  title: string;
  summary: string;
  imagePath: string;
  date: string;
  slug: string;
  animationDelay?: string;
}
@Component({
    selector: 'app-blogs',
        standalone: true,
imports: [
    BreadCrumbsComponent,
    PaginationComponent,
    RouterLink,
    LocalDateTimePipe,
    SkeletonLoaderComponent,
    TranslatePipe,
    FormsModule
],
    templateUrl: './blogs.component.html',
    styleUrl: './blogs.component.scss',
    providers: [LocalDateTimePipe]
})
export class BlogsComponent {
  breadcrumbs: Breadcrumb[] = [];
  blogs: BlogItem[] = [];
  popularBlogs: BlogItem[] = [];
  itemsPerPage = 4;
  page = 1;
  paginationData!: {
    totalPages: number;
    total: number | undefined;
  };
  isLoading: boolean = false;
  currentLang: any;
  searchTerm: string = '';

  isLoadingPopular: boolean = false; // Separate loading state

  constructor(
    private homeService: LandingService,
    private toastService: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService
  ,
    public localeService: LocaleService
  ) {
    this.loadPopularBlogs();

    this.route.queryParams.subscribe((params) => {
      this.page = +params['page'] || 1;
      this.searchTerm = params['search'] || '';

      this.loadBlogs(this.itemsPerPage).subscribe((blogs) => {
        this.blogs = blogs;
      });
    });
  }
  ngOnInit() {
  }

  // Return an Observable of blogs with images
  loadBlogs(perPages: number): Observable<any[]> {
    this.isLoading = true;
    const itemsToFetch = perPages;

    return this.homeService
      .getBlogs(this.page, itemsToFetch, { observe: 'response' }, this.searchTerm)
      .pipe(
        map((fullResponse: any) => {
          // Access the actual blog items from the response body
          const blogs = fullResponse.body?.data || [];
          const pagination = {
            total: fullResponse.body?.pagination?.total_posts,
            totalPages: fullResponse.body?.pagination?.last_page,
          };

          // Set pagination data if available
          if (fullResponse.body?.pagination) {
            this.paginationData = getPaginationData(pagination, itemsToFetch);
          }

          this.isLoading = false;
          return blogs;
        }),
        catchError((error) => {
          this.isLoading = false;
          console.error('Error fetching Blogs:', error);
          this.toastService.showError(
            error?.error?.Error?.[0] ??
              'An error occurred while fetching Blogs.'
          );
          // Return empty array in case of error
          return of([]);
        })
      );
  }
  loadPopularBlogs(): void {
    this.isLoadingPopular = true;

    this.homeService
      .getBlogs(1, 3, { observe: 'response' }) // Always get page 1, first 3 items
      .pipe(
        map((fullResponse: any) => fullResponse.body?.data || []),
        catchError((error) => {
          console.error('Error fetching popular blogs:', error);
          return of([]);
        })
      )
      .subscribe((blogs) => {
        this.popularBlogs = blogs.slice(0, 3); // Store first 3 blogs
        this.isLoadingPopular = false;
      });
  }
  getFeaturedBlog(): Observable<any[]> {
    return this.loadBlogs(1);
  }

  onPageChange(page: number) {
    this.page = page;
    const queryParams: any = { page };
    if (this.searchTerm) {
      queryParams.search = this.searchTerm;
    }

    this.router.navigate(['/blogs'], {
      queryParams,
    });
  }

  onSearch() {
    this.page = 1;
    const queryParams: any = { page: 1 };
    if (this.searchTerm) {
      queryParams.search = this.searchTerm;
    }

    this.router.navigate(['/blogs'], {
      queryParams,
    });
  }

}
